<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/logs:elevator-week.title') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          @clickedButton1="showJson"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="logDate"
          sort-desc
          @cacheCommit="$store.commit('display/logs/logsSearchUpdate', {searchTerm:$event, searchType: 'elevatorWeek'})"
          :cachedSearch="$store.state.display.logs.elevatorWeekLogsSearch"
          :customPanel="createPanel()"
        />

      </v-col>
    </v-row>

    <JsonLogShow
      ref="dialogShow"
    />
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import LogsService from '@/modules/display/services/logs-service';
import JsonLogShow from "@/modules/display/views/logs/dialog/JsonLogShow";
import TablePanel from "@/modules/display/views/logs/TablePanel";
import DataUtils from '@/modules/core/services/data-utils';
import Log from "@/modules/display/data/log";
import Utils from '@/modules/core/services/utils';
import Vue from "vue";
import {i18n} from '@/plugins/i18next';

export default {
  name: "ElevatorWeekTable",
  components: {
    DataTablePaginated,
    JsonLogShow
  },
  data() {
    return {
      filterHours: true
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('display/logs:elevator-day.id'), value: 'id' },
        { text: this.$t('display/logs:elevator-day.elevator-id'), value: 'elevator.id' },
        { text: this.$t('common:date'), value: 'logDate' },
        { text: this.$t('display/logs:elevator-day.free-space'), value: 'playoutFreespaceCount' },
        { text: this.$t('common:budget'), value: 'playoutBudgetCount' },
        { text: this.$t('display/logs:elevator-day.inhouse'), value: 'playoutInhouseCount' },
        { text: this.$t('display/logs:elevator-day.revenue'), value: 'revenue' },
        { text: this.$t('display/logs:elevator-day.motions'), value: 'rideCount' }
      ]
    }
  },
  methods: {
    showJson(item) {
      this.$refs.dialogShow.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;
      let filter = {filter24: this.filterHours};

      LogsService.readAllLogsPaginated(
        'aggregate/elevator/week',
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        filter,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Log);
            for (let i = 0; i < response.data.content.length; i++) {
              response.data.content[i].id = i;
            }
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/logs:download.download-log-table')}));
        }
      );
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n,
        propsData: {filterValue: this.filterHours}
      });
      instance.$on('customPanelValueUpdated', this.updateFilter);
      return instance;
    },
    updateFilter(value) {
      this.filterHours = value;
      this.$refs.table.callTableUpdate()
    }
  }
}
</script>
